"use client";

import error from "@repo/next-shared/utils/providers/error-boundary";

export default error;
